<pp-select
  class="valueBreakdownSitePicker"
  [ppItems]="assetSites"
  [ppSelectedItem]="assetSites[assetSiteIndex]"
  (ppSelectItem)="selectSite($event)"
  [ppNoSearchBar]="true"
  >
  <ng-container selected>
    @if (assetSiteIndex !== -1) {
      <span
        class="valueBreakdownSitePicker__value"
        ppTooltip
        [ppTrimTooltip]="true"
        [ppTitle]="assetSites[assetSiteIndex].label"
        >
        {{ assetSites[assetSiteIndex].label }}
      </span>
    }

    @if (assetSiteIndex === -1) {
      <span class="costField__input__placeholder">
        {{ 'select_site' | ppTranslate }}
      </span>
    }
  </ng-container>
</pp-select>
